"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Icon_1 = require("../Icon");
var Tag = function (_a) {
    var icon = _a.icon, mods = _a.mods, text = _a.text, testId = _a.testId;
    var classes = mods ? "Tag " + mods : 'Tag';
    return (React.createElement("span", { className: classes, "data-testid": testId },
        icon && (React.createElement(Icon_1.Icon, { className: "Icon u-spaceRightXs", style: {
                width: '1.0em',
                height: '1.0em',
            }, name: icon })),
        text));
};
exports.default = Tag;
